import oData from '../server/odata_client';
import rData from '../server/rest_client';
import Util from '../script/utils.js';

export const SET_DATACOMMUNICATIONQRCODE = 'SET_DATACOMMUNICATIONQRCODE';
export const SET_PRIVATEUSER = 'SET_PRIVATEUSER';
export const SET_PRIVATEUSERRESULT = 'SET_PRIVATEUSERRESULT';

export function setDataCommunicationQrcode(dataCommunicationQrcode) {
    return {
        type: SET_DATACOMMUNICATIONQRCODE,
        dataCommunicationQrcode
    }
}

export function setPrivateUser(privateUser) {
    return {
        type: SET_PRIVATEUSER,
        privateUser
    }
}

export function setPrivateUserResult(privateUserResult) {
    return {
        type: SET_PRIVATEUSERRESULT,
        privateUserResult
    }
}

//获取数据通讯二维码
export function getDataCommunicationQrcode(callback){
  return dispatch => {
    rData.getDataCommunicationQrcode((data)=>{
      dispatch(setDataCommunicationQrcode(data));
      callback && callback(data);
    }, (status)=>{
      dispatch(setDataCommunicationQrcode(""));
      callback && callback("");
      Util.showMessageDialog("提示","获取数据通讯二维码失败。");
    });
  }
}

//获取私有用户
export function getPrivateUser(callback){
  return dispatch => {
    oData.getPrivateUser((data)=>{
      dispatch(setPrivateUser(data));
      callback && callback(data);
    }, (status)=>{
      dispatch(setPrivateUser(null));
      callback && callback({});
      Util.showMessageDialog("提示","获取私有用户失败。");
    });
  }
}

//操作私有用户
export function handlePrivateUser(params, callback){
  return dispatch => {
    rData.handlePrivateUser(params, (data)=>{
      // console.log(data);
      dispatch(setPrivateUserResult(data));
      callback && callback(1);
    }, (status)=>{
      // console.log(status);
      dispatch(setPrivateUserResult(null));
      callback && callback(0);
      if (status.errmsg !== 'token invalid.' && !status.errmsg) {
        status.errmsg = "操作私有用户失败。";
      }
      Utils.showInterfaceErrorInfo(status);
    });
  }
}
